/**
 * Formations & Formation Catalogue endpoints
 */

export const formationCatalogueEndpoints = {
  list: () => '/api/formation-catalogue',
}

export const formationsEndpoints = {
  list: () => '/api/public/formations',
  sessions: () => '/api/public/formations/sessions',
  categoriesDistinct: () => '/api/formations/categories',
  categories: {
    list: () => '/api/formation-categories',
    detail: (id) => `/api/formation-categories/${id}`,
    create: () => '/api/formation-categories',
    update: (id) => `/api/formation-categories/${id}`,
    delete: (id) => `/api/formation-categories/${id}`,
    // Arbre d'administration : chaque catégorie avec ses compétences et son matériel.
    arbre: () => '/api/formation-categories/arbre',
    reordonnerCompetences: (id) => `/api/formation-categories/${id}/competences/reordonner`,
    deplacerCompetence: (competenceId) =>
      `/api/formation-categories/competences/${competenceId}/deplacer`,
    materiels: (id) => `/api/formation-categories/${id}/materiels`,
    detacherMateriel: (id, materielId) =>
      `/api/formation-categories/${id}/materiels/${materielId}`,
    reordonnerMateriels: (id) => `/api/formation-categories/${id}/materiels/reordonner`
  },
  messages: () => '/api/formation-messages',
  message: (id) => `/api/formation-messages/${id}`,
  argumentaires: {
    list: () => '/api/formation-argumentaires',
    byType: (type) => `/api/formation-argumentaires/type/${type}`,
    byFormation: (formationNom) => `/api/formation-argumentaires/formation/${encodeURIComponent(formationNom)}`,
    forQuote: (formationNom) => `/api/formation-argumentaires/quote/${encodeURIComponent(formationNom)}`,
    formationsList: () => '/api/formation-argumentaires/formations-list',
    detail: (id) => `/api/formation-argumentaires/${id}`,
    create: () => '/api/formation-argumentaires',
    update: (id) => `/api/formation-argumentaires/${id}`,
    delete: (id) => `/api/formation-argumentaires/${id}`
  }
}
